import { Component, Vue, Inject } from 'vue-property-decorator';
import { getSchoolInfo } from '@/utils/utils';

@Component
export default class Form extends Vue {
  @Inject() public readonly config!: any;

  public get school() {
    return getSchoolInfo().shortName;
  }

  public get rules() {
    return {
      name: {
        validateTrigger: 'blur',
        rules: [
          {
            max: 50,
            min: 1,
            whitespace: true,
            message: this.$t('warningTip.nameInvaild'),
          },
        ],
      },
      enName: {
        validateTrigger: 'blur',
        rules: [
          {
            whitespace: true,
            pattern: /^[a-zA-Z\s]{1,50}$/,
            message: this.$t('warningTip.enNameInvaild'),
          },
        ],
      },
      pinyinName: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            whitespace: true,
            pattern: /^[a-zA-Z\s]{1,50}$/,
            message: this.$t('warningTip.pinyinNameInvaild'),
          },
        ],
      },
      idNumber: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.idNumberInvaild'),
            max: 50,
            min: 1,
            whitespace: true,
          },
        ],
      },
      address: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            max: 50,
            min: 1,
            whitespace: true,
            message: this.$t('warningTip.addressInvaild'),
          },
        ],
      },
      location: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            max: 50,
            min: 1,
            whitespace: true,
            message: this.$t('warningTip.addressInvaild'),
          },
        ],
      },
      schoolNowExtra: {
        rules: [
          {
            min: 1,
            max: 50,
            whitespace: true,
          },
        ],
      },
      mobile: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.mobileInvaild'),
            pattern: /^[0-9]+$/,
            whitespace: true,
          },
        ],
      },
      workUnit: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.workUnitInvaild'),
            max: 50,
            min: 1,
            whitespace: true,
          },
        ],
      },
      position: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.positionInvaild'),
            max: 50,
            min: 1,
            whitespace: true,
          },
        ],
      },
      email: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.emailInvaild'),
            type: 'email',
            whitespace: true,
          },
        ],
      },
      trimEmail: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.emailInvaild'),
            pattern: /^[ a-zA-Z0-9_.-]+@[ a-zA-Z0-9-]+(\.[ a-zA-Z0-9-]+)*\.[ a-zA-Z0-9]{2,6}$/,
            whitespace: true,
          },
        ],
      },
      remark: {
        validateTrigger: 'blur',
        rules: [
          {
            message: this.$t('warningTip.remarkInvaild'),
            whitespace: true,
          },
        ],
      },
      wxid: {
        rules: [
          {
            required: true,
            message: this.$t('warningTip.nameInvaild'),
            whitespace: true,
          },
        ],
      },
      graduatedFrom: {
        validateTrigger: 'blur',
        rules: [
          {
            message: this.$t('warningTip.schoolExtraInvaild'),
            max: 50,
            min: 1,
            whitespace: true,
          },
        ],
      },
      required: {
        rules: [
          {
            required: true,
            message: this.$t('pleaseSelect'),
          },
        ],
      },
      isKsRequired: {
        rules: [
          {
            required: this.config[this.school].isBoardingAndBusRequired,
            message: this.$t('pleaseSelect'),
          },
        ],
      },
      contentRequired: {
        rules: [
          {
            required: true,
            message: this.$t('warningTip.contentNotEmpty'),
          },
        ],
      },
    };
  }

  public get locale(): string {
    return this.$i18n.locale;
  }
}
